// --- START OF REFACTORED FILE LimitesCLG.tsx ---

import React, {useState} from 'react';
import {Alert, Grid, Stack} from "@mui/material";
import {CLGLimitesPorPais, useLimiteCLG} from "../../sistema/sistemas/clg/hooks/useLimiteCLG";
import {OperacionCLGFields, OperacionCLGSectorComercialFields} from "../../sistema/sistemas/clg/types/fields";
import {QueryStatus} from "../../../types";
import CardLimite from "../CardLimite";
import LimitesCLGSectorComercial from './LimitesCLGSectorComercial';
import {SistemaTipo} from "../../../types/enum/enum";
import {FiltrosBusqueda, FormFiltros, FormFiltrosFields, schemaFiltrosBusqueda} from '../FiltrosBusqueda';

interface LimitesCLGProps {

}

function LimitesCLG() {
    const [apiFiltros, setApiFiltros] = useState<FormFiltros>(
        schemaFiltrosBusqueda.parse({})
    );
    const {data, status} = useLimiteCLG(apiFiltros);

    const handleFilterChange = (nuevosFiltros: FormFiltros) => {
        setApiFiltros(nuevosFiltros);
    };

    return (
        <Grid container gap={10}>
            <Grid item xs={12} sx={{mb: -5}}>
                <FiltrosBusqueda
                    formFields={[
                        FormFiltrosFields.Pais,
                        FormFiltrosFields.SectorComercial
                    ]}
                    mensajeTipo={SistemaTipo.CLG}
                    onFilterChange={handleFilterChange}
                    debounceFields={[]}
                />
            </Grid>

            <Grid item xs={12}>
                {status === QueryStatus.Success && data &&
                    data.map((paisProcesado: CLGLimitesPorPais) => (
                        <Stack key={paisProcesado.pais[OperacionCLGFields.CodPais]} gap={1}>
                            <CardLimite
                                codPais={paisProcesado.pais[OperacionCLGFields.CodPais]}
                                pais={paisProcesado.pais[OperacionCLGFields.NombrePais]}
                            />

                            {paisProcesado.sectores.map(sectorProcesado => (
                                <LimitesCLGSectorComercial
                                    key={sectorProcesado.sector[OperacionCLGSectorComercialFields.CodSectorComercial]}
                                    sectorProcesado={sectorProcesado}
                                />
                            ))}
                        </Stack>
                    ))}
            </Grid>
            <Grid item xs={12}>
                {(!data?.length && status === QueryStatus.Success) &&
                    <Alert severity="warning">No se encontraron datos.</Alert>
                }
            </Grid>
        </Grid>
    );
}

export default LimitesCLG;
